module.exports = __webpack_public_path__ + "static/TTNormsProRegular-974a28894dfefba824dc5cdb98836625.woff2";